/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCircleXmarkFill: {
  name: 'circle-xmark-fill';
  data: string;
} = {
  name: 'circle-xmark-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm2.707 8.707a1 1 0 0 0-1.414-1.414L12 10.586l-1.293-1.293a1 1 0 0 0-1.414 1.414L10.586 12l-1.293 1.293a1 1 0 1 0 1.414 1.414L12 13.414l1.293 1.293a1 1 0 0 0 1.414-1.414L13.414 12l1.293-1.293Z" fill="currentColor"/></svg>`,
};
